/*-----------------------------------------------------------------------------------*/
/* MAIN
/*-----------------------------------------------------------------------------------*/
var $ = jQuery.noConflict()

jQuery(document).ready(function ($) {
	// mobile menu
	$('.toggle-sidebar,.bg-overly').on('click', function (e) {
		$('.bg-overly,.toggle-sidebar,body,.main-header').toggleClass('is-visible')
		e.preventDefault()
	})

	if ($('.main-header').length) {
		if (jQuery(this).scrollTop() > 100) {
			$('.main-header').addClass('fixed-header')
			$('#MainContent').addClass('fix-body')
		} else {
			$('.main-header').removeClass('fixed-header')
			$('#MainContent').removeClass('fix-body')
		}
		$(window).scroll(function () {
			if (jQuery(this).scrollTop() > 100) {
				$('.main-header').addClass('fixed-header')
				$('#MainContent').addClass('fix-body')
			} else {
				$('.main-header').removeClass('fixed-header')
				$('#MainContent').removeClass('fix-body')
			}
		})
	}

	$('.collapse-item .collapse-title').click(function () {
		var $thisItem = $(this).closest('.collapse-item') // The current item
		var $parentItems = $thisItem.siblings('.collapse-item') // Sibling items at the same level
		if ($thisItem.hasClass('is-open')) {
			$thisItem.removeClass('is-open')
			$thisItem.find('.collapse-body').first().slideUp() // Close only the current item's body
		} else {
			$parentItems.removeClass('is-open') // Close sibling items
			$parentItems.find('.collapse-body').slideUp() // Slide up their bodies
			$thisItem.addClass('is-open')
			$thisItem.find('.collapse-body').first().slideDown() // Open only the current item's body
		}
		return false
	})
})

// Update Cart Bubble in the Header
function updateCartBubble() {
	fetch('/cart.js')
		.then((response) => response.json())
		.then((cart) => {
			const cartBubble = document.querySelector('.cart-count-bubble')
			const cartItemCount = cart.item_count

			if (cartItemCount > 0) {
				if (cartBubble) {
					cartBubble.querySelector('span[aria-hidden="true"]').textContent =
						cartItemCount
				} else {
					const bubbleHtml = `
						<div class="cart-count-bubble">
							<span aria-hidden="true">${cartItemCount}</span>
							<span class="visually-hidden">${cartItemCount} items in cart</span>
						</div>
					`
					document
						.querySelector('#cart-icon-bubble')
						.insertAdjacentHTML('beforeend', bubbleHtml)
				}
			} else if (cartBubble) {
				cartBubble.remove()
			}
		})
		.catch((error) => console.error('Error fetching cart:', error))
}

// Add to Cart form dynamic Global
// const addToCartSelectors = document.querySelectorAll(
// 	'[id^="dynamic-form-template--"]'
// )
// addToCartSelectors.forEach((selector) => {
// 	// selector.addEventListener('change', updateSelectedVariantId); // Update variant ID on change
// 	console.log(selector)
// })

// document.querySelector('#related-form-template--{{ best_seller_product.id }}').addEventListener('submit', function(e) {
// 	e.preventDefault();

// 	const form = this;
// 	const variantId = document.querySelector('#upsell-variant-id').value; // Get the current selected variant ID
// 	const quantity = 1;

// 	const upsellAddToCartBtn = document.querySelector('#add-to-cart-btn-{{ best_seller_product.id }}');
// 	const upsellSpinner = upsellAddToCartBtn.querySelector('#add-to-cart-btn-{{ best_seller_product.id }} .loading-spinner');
// 	const upsellBtnText = upsellAddToCartBtn.querySelector('#add-to-cart-btn-{{ best_seller_product.id }} .upsell-btn-text');

// 	// Show upsellSpinner, hide button text, disable the button, and add "disabled" class
// 	upsellBtnText.style.display = 'none';
// 	upsellSpinner.style.display = 'inline-block';
// 	upsellAddToCartBtn.disabled = true;
// 	upsellAddToCartBtn.classList.add('disabled');

// 	fetch('/cart/add.js', {
// 		method: 'POST',
// 		headers: {
// 			'Content-Type': 'application/json',
// 			'Accept': 'application/json'
// 		},
// 		body: JSON.stringify({
// 			id: variantId,
// 			quantity: quantity
// 		})
// 	})
// 	.then(response => response.json())
// 	.then(data => {
// 		// After adding to cart, revert to original button text, enable the button, and remove "disabled" class
// 		upsellSpinner.style.display = 'none';
// 		upsellBtnText.style.display = 'inline-block';
// 		upsellAddToCartBtn.disabled = false;
// 		upsellAddToCartBtn.classList.remove('disabled');

// 		// Update the cart item count bubble in the header
// 		updateCartBubble();

// 		// Trigger cart notification manually (if needed)
// 		if (typeof window.CartNotification !== 'undefined') {
// 			const cartNotification = new window.CartNotification();
// 			cartNotification.renderContents(data); // Pass the cart data from the response
// 		}

// 		// Show cart drawer after product is added
// 		if (typeof window.CartDrawer !== 'undefined') {
// 			const cartDrawer = new window.CartDrawer();
// 			cartDrawer.open(); // Trigger the cart drawer to open
// 		}
// 	})
// 	.catch(error => {
// 		console.error('Error adding to cart:', error);
// 		alert('There was an error adding the product to the cart.');
// 		// Revert to original button text and remove "disabled" class in case of error
// 		upsellSpinner.style.display = 'none';
// 		upsellBtnText.style.display = 'inline-block';
// 		upsellAddToCartBtn.disabled = false;
// 		upsellAddToCartBtn.classList.remove('disabled');
// 	});
// });
// // Add to Cart form dynamic Global
